import React from 'react';
import { Row, Col, Card, Spinner } from 'react-bootstrap';
import { FaMapMarkerAlt } from 'react-icons/fa';

const renderStatusPill = (label, color) => (
    <span
        key={label}
        style={{
            backgroundColor: color,
            color: 'white',
            padding: '4px 10px',
            borderRadius: '20px',
            fontSize: '0.65rem',
            fontWeight: '600',
            textTransform: 'uppercase',
            letterSpacing: '0.3px',
            marginRight: '4px',
            marginBottom: '4px',
            display: 'inline-block'
        }}
    >
        {label}
    </span>
);

const EmpreendimentoCard = ({ emp, onVerDetalhes }) => (
    <Col xs={12} sm={6} md={4} lg={3} className="mb-4">
        <Card
            className="h-100 empreendimento-card"
            onClick={() => onVerDetalhes(emp.codigo_familia)}
            style={{
                cursor: 'pointer',
                borderRadius: '12px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                border: 'none',
                overflow: 'hidden'
            }}
        >
            <div className="position-relative" style={{ height: '180px', overflow: 'hidden' }}>
                {emp.imagem_capa ? (
                    <img
                        src={emp.imagem_capa}
                        alt={emp.nome}
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                        }}
                    />
                ) : (
                    <div
                        style={{
                            height: '100%',
                            background: 'linear-gradient(135deg, #1a5276 0%, #2e86ab 50%, #45b7aa 100%)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <FaMapMarkerAlt size={50} className="text-white" style={{ opacity: 0.3 }} />
                    </div>
                )}
                {(emp.imagem_logo || emp.imagem_principal) && (
                    <div
                        style={{
                            position: 'absolute',
                            bottom: '10px',
                            right: '10px',
                            backgroundColor: 'white',
                            padding: '6px 10px',
                            borderRadius: '4px',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                            transform: 'skewX(-5deg)'
                        }}
                    >
                        <img
                            src={emp.imagem_logo || emp.imagem_principal}
                            alt={emp.nome + ' logo'}
                            style={{
                                height: '28px',
                                width: 'auto',
                                transform: 'skewX(5deg)'
                            }}
                        />
                    </div>
                )}
            </div>
            <Card.Body className="d-flex flex-column pt-2 pb-3">
                {(emp.pronto_construir || emp.terrenos_disponiveis || emp.lancamento || emp.em_obras || emp.breve_lancamento) && (
                    <div className="mb-2" style={{ lineHeight: '1.8' }}>
                        {emp.pronto_construir && renderStatusPill('Pronto p/ Construir', '#0066cc')}
                        {emp.terrenos_disponiveis && renderStatusPill('Terrenos Disponíveis', '#28a745')}
                        {emp.lancamento && renderStatusPill('Lançamento', '#ff6600')}
                        {emp.em_obras && renderStatusPill('Em Obras', '#ffc107')}
                        {emp.breve_lancamento && renderStatusPill('Breve Lançamento', '#6c757d')}
                    </div>
                )}
                <small className="text-muted" style={{ fontSize: '0.75rem' }}>
                    {emp.cidade}, {emp.estado}
                </small>
                <Card.Title className="mt-1 mb-1" style={{ fontSize: '1rem', fontWeight: '700' }}>
                    {emp.nome}
                </Card.Title>
                {emp.descricao && (
                    <Card.Text className="text-muted flex-grow-1" style={{ fontSize: '0.8rem', lineHeight: '1.4' }}>
                        {emp.descricao.length > 80
                            ? emp.descricao.substring(0, 80) + '...'
                            : emp.descricao}
                    </Card.Text>
                )}
            </Card.Body>
        </Card>
    </Col>
);

const EmpreendimentosTab = ({ empreendimentos, loading, onVerDetalhes }) => {
    if (loading) {
        return (
            <div className="text-center py-5">
                <Spinner animation="border" role="status">
                    <span className="sr-only">Carregando...</span>
                </Spinner>
            </div>
        );
    }

    if (empreendimentos.length === 0) {
        return (
            <div className="text-center py-5 text-muted">
                <p>Nenhum empreendimento encontrado.</p>
                <p className="small">Use os filtros acima e clique em "Buscar" para visualizar os empreendimentos.</p>
            </div>
        );
    }

    return (
        <Row>
            {empreendimentos.map(emp => (
                <EmpreendimentoCard
                    key={emp.codigo_familia}
                    emp={emp}
                    onVerDetalhes={onVerDetalhes}
                />
            ))}
        </Row>
    );
};

export { renderStatusPill };
export default EmpreendimentosTab;
